<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Profile</li>
      </ol>
      <div class="emp-button btn-align text-right"
           v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))">
        <button type="button" data-toggle="modal" data-target="#creat-employee" class="btn btn-outline-primary">Create
          New Employee
        </button>
      </div>
    </div>
    <div class="main-box two-column">
      <employee-sidebar v-bind:employeeData="employeeId"></employee-sidebar>
      <div class="emplyee-info-wrp bg-transparent p-0">
        <div class="main-box profile-page">

          <h3>Upcoming Shifts</h3>
          <div class="shift-holder">
            <clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor"></clip-loader>
            <div v-if="ComingShiftsAvail">Shifts not available</div>
            <div v-for="(shifts, indexx) of upComingShifts" :key="indexx">
              <time class="timing-tag ml-10">
                {{ indexx | moment("DD-MM-YYYY") }}
              </time>
              <div class="d-flex ml-10">
                <div class="card-wrapper" v-for="(shift, index) of shifts" :key="index">
                  <time class="timing-tag shiftTimeCol">{{ moment(indexx + ' ' + shift.start_time).format("HH:mm") }}
                    -
                    {{ moment(indexx + ' ' + shift.end_time).format("HH:mm") }}
                  </time>
                  <div class="mini-card pointerEvent" :id="'boxShift_'+indexx" @click="showAttendanceCard(shift)">
                    <div class="card-body text-capitalize">
                      <h4>{{ shift.employee.name }} <b :id="'durationType_'+indexx" class="durationType"></b></h4>
                      <span class="emp-designation"><i class="ico ico-fill-circle"
                                                       v-bind:style="{'color' : shift.jobRole.color}"></i>
                                            {{ shift.jobRole.name }}
                                        </span>
                      <time class="timing-tag">
                                            <span v-if="shift.attendance && shift.attendance !== null">
                                                <span>
                                                    {{ moment(shift.attendance.punch_in_time).format("HH:mm") }}
                                                </span>
                                                -
                                                <span v-if="shift.attendance.punch_out_time"> {{
                                                    moment(shift.attendance.punch_out_time).format("HH:mm")
                                                  }} </span>
                                                <span v-else>00:00</span>
                                            </span>
                        <span v-else> {{ "00:00" }} - {{ "00:00" }} </span>
                      </time>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="main-box profile-page">
          <h3>Past Shifts</h3>
          <div class="shift-holder">
            <clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor"></clip-loader>
            <div v-if="!pastShiftsAvail">Shifts not available</div>
            <div v-else>
              <div v-for="(allShifts, shIndex) in pastShifts" :key="shIndex" class="row">
                <h5 class="col-12 mt-20">{{ shIndex }}</h5>
                <div v-for="(shifts, indexx) in allShifts" :key="indexx" class="cardHeadCus">
                  <time class="timing-tag ml-10">
                    {{ indexx | moment("DD-MM-YYYY") }}
                  </time>

                  <div class="d-flex ml-10">
                    <div class="card-wrapper" v-for="(shift, index) in shifts" :key="index">
                      <time class="timing-tag shiftTimeCol">
                        {{ moment(indexx + ' ' + (shift.start_time || '')).format("HH:mm") }}
                        -
                        {{ moment(indexx + ' ' + (shift.end_time || '')).format("HH:mm") }}
                      </time>
                      <div class="mini-card border-gray pointerEvent"
                           :class="{
                               'lateArrivalBGYellowClass': shift.attendance && shift.attendance !== null && !lateArrivalBG(shift),
                               'absentWithoutInformClass': !shift.attendance
                             }"
                           :id="'boxShift_' + indexx"
                           @click="showAttendanceCard(shift)">
                        <span v-if="shift.date && shift.attendances.length===0">

                        <i @click="deleteSchedule(shift.id)" :id="shift.id" v-if="removeBtn" class="fa fa-remove fa-remove-custom"></i>
                      </span>
                        <div class="card-body text-capitalize">
                          <h4 v-if="shift.employee && shift.employee.name">{{ shift.employee.name }} <b :id="'durationType_'+indexx" class="durationType"></b></h4>
                          <span class="emp-designation" v-if="shift.jobRole && shift.jobRole.color">
                            <i class="ico ico-fill-circle" :style="{ 'color': shift.jobRole.color }"></i>
                            {{ shift.jobRole.name }}
                          </span>
                          <div class="time-diplay col-gay">
                            <time class="timing-tag">
                            <span v-if="shift.attendance && shift.attendance !== null">
                              <span>{{ moment(shift.attendance.punch_in_time).format("HH:mm") }}</span>
                              -
                              <span v-if="shift.attendance.punch_out_time">
                                {{ moment(shift.attendance.punch_out_time).format("HH:mm") }}
                              </span>
                              <span v-else>00:00</span>
                            </span>
                              <span v-else>{{ "00:00" }} - {{ "00:00" }}</span>
                            </time>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="text-left">
            <clip-loader :loading="loadingSpin2" :size="size" :color="spinnerColor"></clip-loader>
          </div>
        </div>
        <div class="attendance-report">
          <div class="report-tfoot">
            <div class="container">
              <ul class="rep-info">
                <li class="present" style="border-color:#c7f9c9" title="Pale Green">Total Public Holidays (
                  {{ publicHolidays }} )
                </li>
                <li class="present" style="border-color:rgba(255, 0, 0, 0.48)" title="Red">Full Day ( {{ fullDay }} )
                </li>
                <li class="holiday" style="border-color:rgb(247 217 215)" title="Grey">Half Day ( {{ halfDay }} )</li>
                <li class="weekend" style="border-color:rgb(192 202 255)" title="Dark olive green">Specify Time (
                  {{ specifyTime }} )
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- attendance modal -->
    <div class="modal fade write-msg-model creat-employee-modal" id="cardModal" tabindex="-1" role="dialog"
         aria-labelledby="write-msg-modelLabel" aria-hidden="true"
         v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))">
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <h5 style="color:black" class="text-capitalize">Attendance Mark:&nbsp;<span
                style="color: #4D8FAC">{{ employeeId.name }}</span></h5>

              <span style="color:black"><strong>Shift Time</strong>: {{
                  moment(this.shift.date + ' ' + this.shift.start_time).format('hh:mm a')
                }} -
                            {{ moment(this.shift.date + ' ' + this.shift.end_time).format('hh:mm a') }} </span> &nbsp;&nbsp;<span
              style="color:black"><strong>Date</strong>:{{ this.shiftDate }}</span>
            </div>
            <button type="button" class="close" ref="closeModal" data-dismiss="modal" aria-label="Close">
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="scrolling">
              <div class="inputs-wrapper">
                <div class="row mt-4" v-for="(attendance,index) of shift.attendances" :key="index"
                     v-show="shift.attendances && shift.attendances.length !== 0">
                  <div class="col-3">
                    <label>Punch In</label>
                    <input type="time" class="form-control" v-model="attendance.punchIn"
                           @change="validateTime($event,'start')"/>
                  </div>
                  <div class="col-3">
                    <label>Punch Out</label>
                    <input type="time" class="form-control" v-model="attendance.punchOut"
                           @change="validateTime($event,'end')"/>
                  </div>
                  <div class="col-2">
                    <label>Note In</label>
                    <input type="text" class="form-control" v-model="attendance.punch_in_note"/>
                  </div>
                  <div class="col-2">
                    <label>Note Out</label>
                    <input type="text" class="form-control" v-model="attendance.punch_out_note"/>
                  </div>
                  <div class="col-2">
                    <p><label>Action</label></p>
                    <span class="ico-delete text-danger ml-2" style="cursor: pointer; font-size: 25px;"
                          @click="deleteAttendance(index)"></span>
                  </div>
                </div>
                <div class="row mt-4" v-show="shift.attendances && shift.attendances.length==0">
                  <div class="col-3">
                    <label>Punch In</label>
                    <input type="time" class="form-control" v-model="shiftInTime"
                           @change="validateTime($event,'start')"/>
                  </div>
                  <div class="col-3">
                    <label>Punch Out</label>
                    <input type="time" class="form-control" v-model="shiftOutTime"
                           @change="validateTime($event,'end')"/>
                  </div>
                  <div class="col-3">
                    <label>Note In</label>
                    <input type="text" class="form-control" v-model="inNote"/>
                  </div>
                  <div class="col-3">
                    <label>Note Out</label>
                    <input type="text" class="form-control" v-model="outNote"/>
                  </div>
                </div>
                <div class="inputs-holder mt-4">
                  <div class="field-col">
                    <label>Break Time</label>
                    <div class="nav-selectdrop">
                      <select id="inputState" class="form-control" v-model="shift.break_time" :disabled="true">
                        <option :value="'20'" selected="selected">
                          20 Min
                        </option>
                        <option :value="'30'">30 Min</option>
                        <option :value="'40'">40 Min</option>
                        <option :value="'60'">60 Min</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div v-text="errorText" class="text-red"></div>
            </div>
          </div>
          <div class="modal-footer">
            <a href="javascript:void(0)" class="btn btn-outline-warning btn-sm f-bold" data-dismiss="modal">Cancel</a>
            <button type="button" class="btn btn-outline-primary btn-sm f-bold" data-dismiss="modal"
                    :disabled="saveBtnDisable" @click="editShift">
              Update Attendance
            </button>
          </div>
        </div>
      </div>
    </div>
    <createEmployeeModal></createEmployeeModal>
  </div>
</template>

<script>
import createEmployeeModal from "../Employees/createEmployeeModal";
import DatePicker from "vue2-datepicker";
import employeeSidebar from "../Employees/employeeSidebar";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";

export default {
  name: "employeeShifts",
  components: {
    createEmployeeModal,
    DatePicker,
    ClipLoader,
    employeeSidebar
  },
  data() {
    return {
      currentPage: 1,
      totalPages: 1,
      size: '25px',
      spinnerColor: '#00779C',
      loadingSpin: false,
      loadingSpin2: false,
      employeeId: this.$store.getters.getEmployeeProfileId,
      company_id: this.$store.getters.getSelectedCompany.id,
      jobRoles: this.$store.getters.getSelectedCompany.jobRoles,
      upComingShifts: [],
      pastShifts: [],
      shiftCardData: [],
      jobTypesEmployees: [],
      timeIn: "",
      timeOut: "",
      shiftInTime: '',
      shiftOutTime: '',
      shiftDate: '',
      publicHolidays: 0,
      fullDay: 0,
      halfDay: 0,
      specifyTime: 0,
      breakTimeDisable: false,
      ComingShiftsAvail: false,
      pastShiftsAvail: false,
      attendances: [],
      breakTime: '',
      inNote: '',
      outNote: '',
      shift: [],
      errorText: '',
      holidayDates: [],
      saveBtnDisable: false,
      page: 0,
      user: this.$store.getters.getUser,
      removeBtn: true,
    };
  },

  mounted() {
    this.getEmployeeShifts();
    $('.mx-input').addClass('picker-input');

  },
  methods: {
    deleteSchedule(id) {
      $("#cardModal").modal("hide");
      new Swal({
        title: "Delete?",
        icon: "warning",
        text: "Do you really want to delete?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => {
        if (result.value) {
          this.loadingSpin = true;
          axios.delete(this.$Schedules + '/' + id,
            {headers: this.getAuthHeader()})
            .then((res) => {
              if (res.status == 200) {
                this.loadingSpin = false;
                this.getEmployeeShifts();
              }
            }).catch(error => {
              console.log(error);
            })
        }
      });

    },
    lateArrivalBG(shift) {
      if (shift.attendance && shift.attendance !== null) {
        let shiftAttendanceIn = moment(shift.attendance.punch_in_time).format('HH:mm');
        const shiftDateTime = shift.date + ' ' + shift.start_time;
        const shiftStartDateTime = new Date(shiftDateTime);
        const punchInDateTime = new Date(shift.attendance.punch_in_time);
        shiftStartDateTime.setMinutes(shiftStartDateTime.getMinutes() + 31);
        const momentShiftStart = moment(shiftStartDateTime);
        const momentPunchIn = moment(punchInDateTime);
        if (momentPunchIn.isBefore(momentShiftStart)) {
          return true;
        }
      }

    },
    fetchHolidays() {
      this.publicHolidays = 0;
      let params = {
        company_id: this.company_id
      };
      this.$axios.get(this.$HolidayDates, {
        params: params,
        headers: this.getAuthHeader()
      })
        .then(response => {
          this.holidayDates = response.data.result;
          this.holidayDates.forEach(sc => {
            this.publicHolidays++;
            this.setBGColor(sc, '#c7f9c9', 'PH');
          });
        })
        .catch(error => {
          console.error('Error fetching holidays:', error);
        });
    },
    validateTime(event, timing) {
      this.errorText = '';
      this.saveBtnDisable = false;
      $(event.target).css("border-color", "#e6e6e6");
      if (this.shift.is_floating_shift == 0) {
        let shiftStartTime = new Date(this.shift.date + ' ' + this.shift.start_time).getTime();
        let shiftEndTime = new Date(this.shift.date + ' ' + this.shift.end_time).getTime();
        let attendTime = new Date(this.shift.date + ' ' + event.target.value).getTime();
      }
    },
    editShift() {
      if (this.shift.attendances && this.shift.attendances.length == 0) {
        let start = new Date(this.shift.date + ' ' + this.shiftInTime).getTime();
        let end = null;
        if (this.shiftOutTime) {
          end = new Date(this.shift.date + ' ' + this.shiftOutTime).getTime();
          end = start > end ? end + (1000 * 60 * 60 * 24) : end;
        }
        this.shift.attendances = [{
          punchIn: this.shiftInTime,
          punchOut: this.shiftOutTime,
          punch_in_time: moment(this.shift.date + ' ' + this.shiftInTime).format('YYYY-MM-DD HH:mm'),
          punch_out_time: (end) ? moment(new Date(end)).format('YYYY-MM-DD HH:mm') : null,
          punch_in_note: this.inNote,
          punch_out_note: this.outNote,
        }];
      } else {
        this.shift.attendances = this.shift.attendances.map((atd) => {
          let start = new Date(this.shift.date + ' ' + atd.punchIn).getTime();
          let end = null;
          if (atd.punchOut) {
            end = new Date(this.shift.date + ' ' + atd.punchOut).getTime();
            end = start > end ? end + (1000 * 60 * 60 * 24) : end;
          }
          atd.punch_in_time = moment(new Date(start)).format('YYYY-MM-DD HH:mm');
          atd.punch_out_time = (end) ? moment(new Date(end)).format('YYYY-MM-DD HH:mm') : null;
          return atd;
        });
      }
      this.$axios({
        method: "POST",
        data: {
          shift: this.shift,
          punch_in_device_type: "web",
          punch_out_device_type: "web"
        },
        url: this.$UpdateShiftTime,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          $("#cardModal").modal("hide");
          this.page = 0;
          this.getEmployeeShifts();
          $root.$toast.success(res.data.message);
        }
      });
    },
    closeShiftCard(idd) {
      $(".shiftCardShow").removeClass("show");
    },
    showAttendanceCard(shift) {
      this.shiftDate = new Date(shift.date).toDateString();
      this.shiftInTime = shift.start_time;
      this.shiftOutTime = null;
      this.inNote = '';
      this.outNote = '';
      shift.attendances = shift.attendances.reverse().map((atd) => {
        atd.punchIn = moment(atd.punch_in_time).format('HH:mm');
        atd.punchOut = moment(atd.punch_out_time).format('HH:mm');
        return atd;
      });
      this.shift = shift;
      this.breakTimeDisable = false;
      $("#cardModal").modal("show");
    },
    getEmployeeByJobRoleId(event, idd) {
      let id = event.target.value;
      this.$axios({
        method: "get",
        params: {
          job_role_id: id,
          company_id: this.$store.getters.getSelectedCompany.id,
          user_id: idd,
        },
        url: this.$GetEmployeeWithSameRoles,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.jobTypesEmployees = res.data.result;
        }
      });
    },
    hideUpComingCard(cardRef) {
      this.$refs[cardRef][0].classList.remove("show");
    },
    showPastCard(id, shiftIn, shiftOut, shiftDate) {
      this.timeIn = "";
      this.timeOut = "";
      this.shiftDate = new Date(shiftDate).toDateString();
      this.breakTimeDisable = true;
      this.shiftInTime = shiftIn;
      this.shiftOutTime = shiftOut;
      $("#cardModal").modal("show");

      this.$axios({
        method: "get",
        params: {
          shift_id: id,
          user_id: this.$route.params.id,
        },
        url: this.$GetShiftCard,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.shiftCardData = res.data.result;
          if (this.shiftCardData.attendance !== null) {
            this.timeIn = this.shiftCardData.attendance.punch_in_time !== null ? moment(this.shiftCardData.attendance.punch_in_time).format('HH:mm') : moment(shiftDate + ' ' + shiftIn).format('HH:mm');
            this.timeOut = this.shiftCardData.attendance.punch_out_time !== null ? moment(this.shiftCardData.attendance.punch_out_time).format('HH:mm') : moment(shiftDate + ' ' + shiftOut).format('HH:mm');
          } else {
            this.timeIn = moment(shiftDate + ' ' + shiftIn).format('HH:mm');
            this.timeOut = moment(shiftDate + ' ' + shiftOut).format('HH:mm');
          }
        }
      });
    },
    getDates(startDates, endDates) {
      const startDate = moment(startDates);
      const endDate = moment(endDates);
      const datesArray = [];

      while (startDate.isSameOrBefore(endDate, 'day')) {
        datesArray.push(startDate.format('YYYY-MM-DD'));
        startDate.add(1, 'days');
      }

      return datesArray;
    },

    setBGColor(date, color, type) {
      const element = document.getElementById('boxShift_' + moment(date).format('YYYY-MM-DD'));
      const durationType = document.getElementById('durationType_' + moment(date).format('YYYY-MM-DD'));
      if (element && durationType) {
        // Set the background color
        element.style.backgroundColor = color;
        $('#durationType_' + moment(date).format('YYYY-MM-DD')).text('(' + type + ')');
      }
    },
    getEmployeeLeaves(url = null) {
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
          pagination: 'no',
          user_id: this.employeeId.id
        },
        url: (url) ? url : this.$Getleave,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.data.status == 200) {
          this.allLeaves = res.data.result;
          this.allLeaves.forEach(sc => {

            if (sc.duration_type == 'full_day') {
              //console.log(sc, 'sc sc');
              const datesArray = this.getDates(sc.start_datetime, sc.end_datetime);
              datesArray.forEach(date => {
                this.fullDay++
                this.setBGColor(date, 'rgb(241 150 143)', 'FD');
              });
            }
            if (sc.duration_type == 'half_day') {
              this.halfDay += 0.5
              if (sc.is_half_day_type == 'morning') {
                this.setBGColor(sc.start_datetime, 'rgb(247 217 215)', 'HDM');
              } else {
                this.setBGColor(sc.start_datetime, 'rgb(247 217 215)', 'HDE');
              }
            }
            if (sc.duration_type == 'specify_time') {

              this.specifyTime += 0.25
              this.setBGColor(sc.start_datetime, 'rgb(192 202 255)', 'ST');
            }
          });
        }
      });
    },


    getEmployeeShifts() {
      this.publicHolidays = 0;
      this.fullDay = 0;
      this.halfDay = 0;
      this.specifyTime = 0;
      this.loadingSpin = true;
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
          user_id: this.employeeId.id,
          // page        : this.page
        },
        url: this.$GetEmployeeShifts,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.upComingShifts = res.data.result.upComingShifts;
          this.pastShifts = res.data.result.pastShifts;
          this.ComingShiftsAvail = this.upComingShifts.length == 0 ? true : false;
          // this.pastShiftsAvail = this.pastShifts.length == 0 ? true : false;
          this.pastShiftsAvail = Object.keys(this.pastShifts).length > 0;
          this.loadingSpin = false;
          this.getEmployeeLeaves();
          if (this.user && (this.user.type == 'MANAGER' || (this.user.type == 'EMPLOYEE' && this.user.managerAccess == 'yes'))) {
            this.fetchHolidays();
          }

        }
      });
    },

    loadMoreShift() {
      this.fullDay = 0;
      this.halfDay = 0;
      this.specifyTime = 0;
      this.loadingSpin2 = true;
      this.currentPage++;
      // this.pastShifts=[];
      this.$axios({
        method: "get",
        params: {

          company_id: this.$store.getters.getSelectedCompany.id,
          user_id: this.employeeId.id,
          page: this.currentPage
        },
        url: this.$GetEmployeeShifts,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          this.pastShifts = {
            ...this.pastShifts,
            ...res.data.result.pastShifts
          };
          this.loadingSpin2 = false;
          this.getEmployeeLeaves();
          this.fetchHolidays();
        }
      });
    },

    deleteAttendance(index) {
      const attendance = this.shift.attendances[index];
      // Show confirmation dialog
      new Swal({
        title: 'Delete Attendance',
        text: "You are about to delete this attendance record.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$axios.get(this.$DeleteShiftTime + '/' + attendance.id, {
            headers: this.getAuthHeader()
          })
            .then(response => {
              this.shift.attendances.splice(index, 1);
              $root.$toast.success('Attendance deleted successfully.');
            })
            .catch(error => {
              console.error('Error deleting attendance:', error);
            });
        }
      });
    },
  },
};
</script>

<style>
.profile-page .mini-card .card-body .time-diplay .timing-tag {
  color: black !important;
}

.pointerEvent {
  cursor: pointer;
}

.date-picker-width {
  /* height: 100px; */
  width: 100% !important;
}

.picker-input {
  border: 0 !important;
  background: #f6f6f6 !important;
  box-shadow: none !important;
  height: 40px !important;
}

.shiftTimeCol {
  color: #cccccc !important;
}

.inputs-wrapper .row {
  margin-right: 0px !important;
  margin-left: 0px !important;
  margin-bottom: 20px !important;
}

.inputs-wrapper .row .form-control {
  color: #242424;
  font-size: 14px;
  line-height: 18px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}

.inputs-wrapper .row .col-3 {
  padding: 2px !important;
}

.text-red {
  color: red;
}

.lateArrivalBGYellowClass {
  background: #ffe1b4;
}

.absentWithoutInformClass {
  background: pink;
}

.durationType {
  color: black !important;
}

.profile-page .mini-card .card-body h4 {
  font-size: 14px !important;
}
.cardHeadCus{
  position: relative;
}
.cardHeadCus:hover{
  box-shadow: 0px 0px 3px 0px;
}

</style>
